import React from "react";

const statusStyles = {
  closed: "bg-green-500",
  inprocess: "bg-primary",
  unsubmitted: "bg-orange-500",
  portal: "bg-[#0bafd430]",
  email: "bg-[#22c55c2e]",
  "sub admin": "bg-[#DDF6E8]",
  employee: "bg-[#0bafd430]",
};

const textStyle = {
  portal: "text-primary",
  email: "text-green-500",
  "sub admin": "text-green-500",
  employee: "text-primary",
};

const StatusBadge = ({ status, statusText, statusColor, statusBgColor }) => {
  const normalizedStatus =
    typeof status === "string" ? status.toLowerCase() : "";
  const bgColor = statusStyles[normalizedStatus] || "bg-gray-400";
  const textColor = textStyle[normalizedStatus] || "text-white";

  return (
    <span
      className={`max-w-[100px] h-[30px] flex items-center justify-center 
     rounded-full ${statusColor || textColor} text-xs sub-title uppercase 
    ${statusBgColor || bgColor}`}
    >
      {statusText || status}
    </span>
  );
};

export default StatusBadge;
